import React from "react";
import styles from "./styles.module.scss";

interface ToggleOnOffProps {
  isEnabled: boolean;
  onToggleOn: () => void;
  onToggleOff: () => void;
  backgroundColor?: string;
  loading?: boolean;
  enabledLabel?: string;
  disabledLabel?: string;
}

const ToggleOnOff = ({
  isEnabled,
  onToggleOn,
  onToggleOff,
  backgroundColor,
  loading,
  enabledLabel = "Enabled",
  disabledLabel = "Disabled",
}: ToggleOnOffProps) => {
  return (
    <div className={styles.toggle_box}>
      <div
        className={`${styles.toggle_container}`}
        style={{ backgroundColor: isEnabled ? backgroundColor : "" }}
        onClick={() => {
          if (loading) return;
          isEnabled ? onToggleOff() : onToggleOn();
        }}
      >
        <div
          className={`${styles.slider} ${isEnabled ? styles.toggled : ""}`}
        ></div>
      </div>
      <div className={styles.toggle_text}>
        {loading ? "Loading..." : isEnabled ? enabledLabel : disabledLabel}
      </div>
    </div>
  );
};

export default ToggleOnOff;
